
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
           .directive('npPin', npPinDirective);

    function npPinDirective() {
        var directive = {
            restrict: 'EA',
            templateUrl: paths.PinView,
            scope: {

            },
            link: linkFunction,
            controller: controller,
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {
            
        };

        controller.$inject = ['$scope', '$window'];

        function controller($scope, $window) {
            var vm = this;

            vm.hideSidebarButton = hideSidebarButton;

            function hideSidebarButton() {
                angular.element('.sidebar-toggle').toggleClass('display--non');
            };
        };
    };

})();